<template>
    <div class="tree">
      <tree :data="tree" node-text="name" layoutType="horizontal"></tree>
    </div>
</template>

<script>
import { tree } from 'vued3tree'
import { TREEDATA } from '../../../treeStaticData'

export default {
  name: 'treeStructure',
  props: ['data', 'title'],
  components: {
    tree
  },
  data: () => {
    return {
      tree: {}
    }
  },

  mounted () {
    this.loadTree()
  },

  methods: {
    loadTree () {
      this.tree = TREEDATA
    }
  },

  computed: {
  },

  watch: {
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/app/explore/components/TreeStructure.vue